module.exports = __webpack_public_path__ + "img/crown.86bbae7b.png";